import { Box, Button, FormLabel, Grid, IconButton, Input, Modal } from '@mui/material';
import { CSVLink } from 'react-csv';
import React, { useEffect, useState } from 'react';
import Iconify from '../../iconify/Iconify';

function StaticEmployeemodel(props) {
  const { Editmodel, handleEditClose, handleChange, state, setState, fielderror, handelEditstatic, data } = props;

  const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
    transition: 'left 0.5s ease-in-out',
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'column',
  };

  const [employeeData, setEmployeeData] = useState({})

  useEffect(()=>{
    setEmployeeData(state)
    setState(state)
  },[state])

  const handleClose=()=>{
    setEmployeeData({})
    handleEditClose()
  }
  
  const handleSubmit=()=>{
    setEmployeeData({})
    handelEditstatic()
  }

  return (
    <>
      <Modal
        style={style2}
        open={Editmodel}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2>Update Static Employee</h2>
            <Iconify style={{ cursor: 'pointer' }} onClick={handleClose} icon={'material-symbols:close'} />
          </div>
          <Grid container spacing={3}>
            {/* Bank */}
            {Object.keys(employeeData)?.length > 0 &&
              Object.keys(employeeData)?.map((e) => {
                return (
                  <Grid sx={style2} item xs={12} sm={6} md={4} xl={4}>
                    <FormLabel>{e} :</FormLabel>
                    <Input type="text" name={e} onChange={handleChange} defaultValue={employeeData?.[e]} />
                    <div style={{ color: 'red' }}>{fielderror?.Bank}</div>
                  </Grid>
                );
              })}
          </Grid>
          <Button style={{ marginTop: '10px', width: '100%' }} onClick={handleSubmit} variant="contained">
            UPLOAD
          </Button>
          <Button style={{ marginTop: '10px', width: '100%' }} onClick={handleClose} variant="contained">
            Cancel
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default StaticEmployeemodel;
